import { useRef, useState } from 'react';

import type { DrawerNode } from './drawer.types';

type UseDrawerProps = {
    onCloseAll: () => void;
    onOpenChange: (isOpen: boolean) => void;
    onOpenChangeComplete: (isOpen: boolean) => void;
};

export function useDrawer({ onCloseAll, onOpenChange, onOpenChangeComplete }: UseDrawerProps) {
    const [activeNode, setActiveNode] = useState<DrawerNode | null>(null);
    const activeTriggerRef = useRef<HTMLElement | null>(null);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const openNode = (node: DrawerNode, trigger: HTMLElement) => {
        activeTriggerRef.current = trigger;
        setActiveNode(node);
    };

    const closeChild = () => {
        setActiveNode(null);
        requestAnimationFrame(() => activeTriggerRef.current?.focus());
    };

    const handleOpenChange = (nextIsOpen: boolean) => onOpenChange(nextIsOpen);

    const handleOpenChangeComplete = (isNowOpen: boolean) => {
        if (!isNowOpen) setActiveNode(null);

        onOpenChangeComplete(isNowOpen);
    };

    const closeAll = () => onCloseAll();

    return {
        activeNode,
        closeAll,
        closeButtonRef,
        closeChild,
        handleOpenChange,
        handleOpenChangeComplete,
        openNode,
    };
}
